import React from "react";
import { faCheckCircle, faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
var Select = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, options = _a.options, placeholder = _a.placeholder, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? "medium" : _d, _e = _a.state, state = _e === void 0 ? "default" : _e, label = _a.label, helpText = _a.helpText, errorMessage = _a.errorMessage, successMessage = _a.successMessage, icon = _a.icon, _f = _a.fullWidth, fullWidth = _f === void 0 ? false : _f, _g = _a.className, className = _g === void 0 ? "" : _g, _h = _a.multiple, multiple = _h === void 0 ? false : _h;
    var handleChange = function (e) {
        var selectedValue = multiple ? Array.from(e.target.selectedOptions, function (option) { return option.value; }) : e.target.value;
        onChange(selectedValue);
    };
    // Determine the actual state based on messages
    var actualState = errorMessage ? "error" : successMessage ? "success" : state;
    // Determine status icon
    var statusIcon = actualState === "error" ? faExclamationCircle : actualState === "success" ? faCheckCircle : icon;
    var wrapperClasses = [
        "lib-select-wrapper",
        "lib-select-".concat(size),
        "lib-select-".concat(actualState),
        disabled ? "lib-select-disabled" : "",
        fullWidth ? "lib-select-full-width" : "",
        statusIcon ? "lib-select-with-icon" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");
    var selectClasses = ["lib-select", actualState !== "default" ? "lib-select-".concat(actualState) : ""]
        .filter(Boolean)
        .join(" ");
    return (React.createElement("div", { className: wrapperClasses },
        label && (React.createElement("label", { htmlFor: id, className: "lib-select-label" },
            label,
            required && React.createElement("span", { className: "lib-select-required" }, "*"))),
        React.createElement("div", { className: "lib-select-container" },
            statusIcon && (React.createElement(FontAwesomeIcon, { icon: statusIcon, className: "lib-select-icon ".concat(actualState !== "default" ? "lib-select-icon-".concat(actualState) : "") })),
            React.createElement("select", { id: id, name: name, className: selectClasses, value: value, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, disabled: disabled, required: required, multiple: multiple },
                placeholder && !multiple && (React.createElement("option", { value: "", disabled: true }, placeholder)),
                options.map(function (option) { return (React.createElement("option", { key: option.value, value: option.value, disabled: option.disabled }, option.label)); }))),
        helpText && !errorMessage && !successMessage && React.createElement("div", { className: "lib-select-help" }, helpText),
        errorMessage && React.createElement("div", { className: "lib-select-error" }, errorMessage),
        successMessage && React.createElement("div", { className: "lib-select-success" }, successMessage)));
};
export default Select;
